'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

LinePlotterDirective=class LinePlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['points','verticalAxis','horizontalAxis','plotArea'];
}
get textBindings(){
return['propNameForX','propNameForY','interpolation','class'];
}

get controller(){
return LinePlotterController;
}};let


LinePlotterController=class LinePlotterController{
static get $inject(){
return['$scope'];
}

constructor($scope){
$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});
}

get _scalesValid(){
return(
_.exists(this.horizontalAxis)&&
_.exists(this.horizontalAxis.scale)&&
_.exists(this.verticalAxis)&&
_.exists(this.verticalAxis.scale));
}

redraw(){
if(!this._scalesValid){
return;
}

let line=d3.svg.line().
x(point=>this.horizontalAxis.scale(point[this.propNameForX])).
y(point=>this.verticalAxis.scale(point[this.propNameForY])).
interpolate(this.interpolation);

d3.select(this.plotArea.svgElement).
append('g').
attr('class',`${this.class}`).
append('path').
attr('fill','none').
attr('d',line(this.points));
}};


module.exports=LinePlotterDirective;
//# sourceMappingURL=linePlotterDirective.js.map
